/**
 * Installment Drawer - Obrah
 * Side panel with payment options
 */
(function() {
  function showDrawer() {
    var drawer = document.getElementById('InstallmentDrawer');
    var overlay = document.getElementById('InstallmentOverlay');
    if (drawer) drawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function hideDrawer() {
    var drawer = document.getElementById('InstallmentDrawer');
    var overlay = document.getElementById('InstallmentOverlay');
    if (drawer) drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.installment-drawer side-panel-close')) {
      hideDrawer();
    }
    if (e.target.id === 'InstallmentOverlay') {
      hideDrawer();
    }
  });

  document.addEventListener('keyup', function(e) {
    if (e.code === 'Escape') hideDrawer();
  });

  function fmt(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function buildCard(titleHTML, totalValue, badge, subtitle, darkBadge) {
    var card = document.createElement('div');
    card.className = 'installment-card';

    var title = document.createElement('div');
    title.className = 'installment-card__title';

    var left = document.createElement('span');
    left.className = 'installment-card__title-left';
    left.innerHTML = titleHTML;

    if (badge) {
      var b = document.createElement('span');
      b.className = 'installment-card__badge';
      b.textContent = badge;
      left.appendChild(b);
    }

    if (darkBadge) {
      var db = document.createElement('span');
      db.className = 'installment-card__badge--dark';
      db.textContent = darkBadge;
      left.appendChild(db);
    }

    title.appendChild(left);

    if (totalValue !== null && !subtitle) {
      var right = document.createElement('span');
      right.className = 'installment-card__total';
      right.textContent = fmt(totalValue);
      title.appendChild(right);
    }

    if (subtitle) {
      var sub = document.createElement('span');
      sub.className = 'installment-card__subtitle';
      sub.innerHTML = subtitle;
      title.appendChild(sub);
    }

    card.appendChild(title);

    return card;
  }

  if (!customElements.get('installment-opener')) {
    class InstallmentOpener extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.addEventListener('click', this.open.bind(this));
      }

      open() {
        var price = parseInt(this.dataset.price, 10);
        if (!price || price <= 0) return;
        this.populateDrawer(price);
        showDrawer();
      }

      populateDrawer(priceCents) {
        var price = priceCents / 100;
        var drawer = document.getElementById('InstallmentDrawer');
        if (!drawer) return;

        var pixDiscount = parseInt(drawer.dataset.pixDiscount || '10', 10);
        var interestRate = parseInt(drawer.dataset.interestRate || '290', 10) / 10000;
        var maxInstallments = parseInt(drawer.dataset.maxInstallments || '12', 10);
        var interestFree = parseInt(drawer.dataset.interestFree || '3', 10);

        var container = document.getElementById('installment-table-body');
        if (!container) return;
        container.innerHTML = '';

        // PIX
        var pixPrice = price * (1 - pixDiscount / 100);
        var pixSavings = price - pixPrice;
        container.appendChild(buildCard(
          '<strong>' + fmt(pixPrice) + '</strong> à vista no PIX',
          null,
          pixDiscount + '% OFF',
          'economize <strong>' + fmt(pixSavings) + '</strong>'
        ));

        // 1x-3x sem juros
        for (var n = 1; n <= interestFree; n++) {
          var val = price / n;
          container.appendChild(buildCard(
            '<strong>' + n + 'x</strong> de <strong>' + fmt(val) + '</strong>',
            price,
            null,
            null,
            'sem juros'
          ));
        }

        // 4x-12x com juros
        for (var n = interestFree + 1; n <= maxInstallments; n++) {
          var factor = Math.pow(1 + interestRate, n);
          var pmt = price * (interestRate * factor) / (factor - 1);
          var total = pmt * n;

          container.appendChild(buildCard(
            '<strong>' + n + 'x</strong> de <strong>' + fmt(pmt) + '</strong>',
            total
          ));
        }
      }
    }

    customElements.define('installment-opener', InstallmentOpener);
  }
})();
